import axios from "axios";
import getInterceptors from '@/modules/common/services/interceptors.js';

let HTTP = null;

const getHTTPInstance = () => {
  if (!HTTP) {
    HTTP = axios.create({
      baseURL: `https://${window.app_config.frontage_location}/`
    });

    const serviceInterceptors = getInterceptors(HTTP);

    HTTP.interceptors.request.use(
      serviceInterceptors.REQUEST.onFulfilled,
      serviceInterceptors.REQUEST.onRejected,
    );

    HTTP.interceptors.response.use(
      serviceInterceptors.RESPONSE.onFulfilled,
      serviceInterceptors.RESPONSE.onRejected,
    );
  }
  return HTTP;
}

const get = (route, params, options = {}) => {
  const config = {params};
  if (options.skipTeamsViewFilter) {
    config.skipTeamsViewFilter = true;
  }
  return getHTTPInstance().get(route, config).then(res => res.data);
}

const put = (route, params) => {
  return getHTTPInstance().put(route, params).then(res => res.data);
}

const post = (route, params) => {
  return getHTTPInstance().post(route, params).then(res => res.data);
}

const remove = (route, params) => {
  return getHTTPInstance().delete(route, params).then(res => res.data);
}

export default {
  get,
  put,
  remove,
  post
};

